import React from "react";
import Hero from "./Hero";
import Specials from "./Specials";
import Testimonials from "./Testimonials";
import About from "./About";
import Header from "./Header";
import Nav from "./Nav";

const HomePage = () => {
  return (
    <body>
      <div class="mb-20">
        <Header>
          <Nav />
        </Header>
      </div>
      <div id="home">
        <Hero />
      </div>
      <div id="specials">
        <Specials />
      </div>
      <div id="reviews">
        <Testimonials />
      </div>
      <div id="about">
        <About />
      </div>
    </body>
  );
};

export default HomePage;
